import React from "react";

const DownloadIcon = ({ className }) => {
  return (
    <svg
      viewBox="0 0 18 19"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M13.6975 8.66049C13.6006 8.44792 13.3878 8.31255 13.1534 8.31255H10.7617V0.593753C10.7617 0.266001 10.4939 0 10.1638 0H7.77214C7.44209 0 7.17423 0.266001 7.17423 0.593753V8.31255H4.78256C4.54818 8.31255 4.33532 8.44911 4.23846 8.66049C4.1404 8.87305 4.17866 9.12124 4.33293 9.29699L8.51834 14.047C8.63195 14.1765 8.79578 14.2501 8.96798 14.2501C9.14018 14.2501 9.30401 14.1753 9.41761 14.047L13.603 9.29699C13.7585 9.12243 13.7944 8.87305 13.6975 8.66049Z" fill="currentColor" />
      <path d="M15.5458 13.0625V16.625H2.39167V13.0625H0V17.8125C0 18.4692 0.535733 19 1.19583 19H16.7417C17.403 19 17.9375 18.4692 17.9375 17.8125V13.0625H15.5458Z" fill="currentColor" />
    </svg>
  );
};

export default DownloadIcon;
